import axios from "axios";
import { API_URL } from "constants/appConstants";
import { authRouteConstants } from "constants/routeConstants";

export const getAccessToken = () => {
    return localStorage.getItem('u-access-token')
} 

export const getDomain = () => {
    const { location } = window;
}


// Get the refresh token from local storage
export const getRefreshToken = () => localStorage.getItem("u-refresh-token");

// Store the access token in local storage
export const setAccessToken = (token) => localStorage.setItem("u-access-token", token);

// Store the refresh token in local storage
export const setRefreshToken = (token) => localStorage.setItem("u-refresh-token",token);


export const refreshToken = async () => {
    try {
        const refreshToken = getRefreshToken(); // Retrieve stored refresh token
        if (!refreshToken) {
           return;
        }

        const response = await axios.post(`${API_URL}/accounts/token/refresh`, {
            refresh: refreshToken
        });
        
        const newAccessToken = response.data.access;

        setAccessToken(newAccessToken);
        setRefreshToken(newAccessToken);

        return newAccessToken;
    } catch (error) {
        console.error("Refresh token failed", error);
        window.location.href = authRouteConstants.LOGOUT; // Redirect to login if refresh fails
        return ;
    }
};

